import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeftContained02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M10.525 16.883a1 1 0 1 0 1.536-1.28l-.768.64zM7.757 12l-.768-.64a1 1 0 0 0 0 1.28zm4.304-3.602a1 1 0 0 0-1.536-1.28l.768.64zM16.243 13a1 1 0 0 0 0-2v2m-4.95 3.243.768-.64-3.535-4.243-.769.64-.768.64 3.536 4.243zM7.757 12l.769.64 3.535-4.242-.768-.64-.768-.64-3.536 4.242zm0 0v1h8.486v-2H7.757zM5.212 5.212l.707.707a8.6 8.6 0 0 1 12.162 0l.707-.707.707-.707c-4.14-4.14-10.85-4.14-14.99 0zm13.576 0-.707.707a8.6 8.6 0 0 1 0 12.162l.707.707.707.707c4.14-4.14 4.14-10.85 0-14.99zm0 13.576-.707-.707a8.6 8.6 0 0 1-12.162 0l-.707.707-.707.707c4.14 4.14 10.85 4.14 14.99 0zm-13.576 0 .707-.707a8.6 8.6 0 0 1 0-12.162l-.707-.707-.707-.707c-4.14 4.14-4.14 10.85 0 14.99z"
    />
  </svg>
);
export default SvgArrowLeftContained02;
